// Arrays.js

/**
 * Chunks an array into smaller arrays of specified size.
 * 
 * @param {Array} items - The array to chunk.
 * @param {number} chunkSize - The maximum size of each chunk.
 * 
 * @returns {Array[]} Array of chunked arrays.
 */
export const chunkArray = (items, chunkSize) => {

	// Validate inputs
	if (!Array.isArray(items) || items.length === 0) return [];

	// Validate chunkSize
	const size = Number(chunkSize);

	// Return single chunk if size is invalid
	if (!Number.isFinite(size) || size <= 0) return [items];

	// Chunking logic
	const chunks = [];

	// Iterate and slice
	for (let i = 0; i < items.length; i += size) {
		chunks.push(items.slice(i, i + size));
	}

	// Return array of chunks
	return chunks;
};